import { Leaf } from "lucide-react";

const TONES = {
  ocean: { bg: "linear-gradient(160deg,#e3eef0 0%,#eef3ec 100%)", ink: "#2F5B69" },
  leaves: { bg: "linear-gradient(160deg,#e4eee1 0%,#f1f4ee 100%)", ink: "#285B45" },
  honey: { bg: "linear-gradient(160deg,#f3e9dc 0%,#f6f2ea 100%)", ink: "#6B4C35" },
  beach: { bg: "linear-gradient(160deg,#efebe3 0%,#f5f3ee 100%)", ink: "#5d5a4c" },
  hibiscus: { bg: "linear-gradient(160deg,#f1e3e1 0%,#f6f1ee 100%)", ink: "#7a3b36" },
};

// Clearly-labelled placeholder used until genuine Uhlumo Organics product photographs are supplied.
export const ProductPlaceholder = ({ product, className = "aspect-[4/3]", size = "md" }) => {
  const tone = TONES[product?.accent] || TONES.leaves;
  return (
    <div
      className={`placeholder-product ${className}`}
      style={{ background: tone.bg }}
      role="img"
      aria-label={`${product?.name || "Product"} — product photograph coming soon`}
      data-testid={`product-placeholder-${product?.slug || "generic"}`}
    >
      <div className="pointer-events-none absolute -right-10 -top-10 h-40 w-40 rounded-full" style={{ background: "rgba(255,255,255,0.55)" }} />
      <div className="pointer-events-none absolute -bottom-12 -left-8 h-36 w-36 rounded-full" style={{ background: "rgba(255,255,255,0.35)" }} />
      <span className="relative mb-3 flex h-11 w-11 items-center justify-center rounded-full border bg-white/70" style={{ color: tone.ink, borderColor: "rgba(40,91,69,0.18)" }}>
        <Leaf className="h-5 w-5" aria-hidden="true" />
      </span>
      <span className={`relative px-4 font-display font-semibold leading-tight ${size === "lg" ? "text-2xl sm:text-3xl" : "text-lg"}`} style={{ color: tone.ink }}>
        {product?.name}
      </span>
      <span className="relative mt-2 text-[11px] font-semibold uppercase tracking-[0.14em] text-muted-foreground">Product photograph coming soon</span>
    </div>
  );
};
